import { useTranslation } from 'react-i18next';

import { Box, Select } from '@electricjs/arc';

import ApplicationOption, { ApplicationOptionProps } from './ApplicationOption';

type ApplicationOptionInfo = {
  name: string;
  id: string;
  icon?: string;
};

type ApplicationSelectProps = {
  id?: string;
  options: ApplicationOptionInfo[] | undefined;
  isLoading?: boolean;
  placeholder?: string;
};

const ApplicationSelect = ({
  id,
  options,
  isLoading,
  placeholder,
  ...props
}: ApplicationSelectProps) => {
  const { t } = useTranslation('support-center');
  const unlistedApp = {
    id: '',
    name: t('applicationSelect.applicationNotListed'),
  };
  const appOptions = [...(options ?? []), unlistedApp];

  return (
    <Box>
      <Select
        {...props}
        id={id ?? 'application-select'}
        options={appOptions}
        isLoading={isLoading}
        placeholder={placeholder}
        isSearchable
        isClearable
        getOptionLabel={application => `${application?.name}`}
        getOptionValue={application => application?.name}
        customComponents={{
          Option: (props: ApplicationOptionProps) => {
            return <ApplicationOption {...props} />;
          },
        }}
      />
    </Box>
  );
};

export default ApplicationSelect;
